import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-0feae888"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "MaterialItem"
};
var _hoisted_2 = {
  class: "item-header flex align-center justify-between"
};
var _hoisted_3 = {
  class: "title"
};
var _hoisted_4 = {
  class: "item-content"
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "物料编码：", -1);
});
var _hoisted_6 = {
  class: "info"
};
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "规格型号：", -1);
});
var _hoisted_8 = {
  class: "info"
};
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "物料单位：", -1);
});
var _hoisted_10 = {
  class: "info"
};
var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "申请数量：", -1);
});
var _hoisted_12 = {
  class: "info"
};
var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "领用状态：", -1);
});
var _hoisted_14 = {
  class: "px-3 top-line"
};
var _hoisted_15 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title font-weight-bold pt-2"
  }, "货位及库存", -1);
});
var _hoisted_16 = {
  style: {
    "line-height": "3"
  }
};
var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "所在货位：", -1);
});
var _hoisted_18 = {
  class: "info"
};
var _hoisted_19 = {
  style: {
    "line-height": "3"
  }
};
var _hoisted_20 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "当前库存：", -1);
});
var _hoisted_21 = {
  class: "info"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.item.stone_name), 1), _ctx.show_status ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_ctx.item.release_status ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    class: "mark yellow",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    function () {
      return _ctx.markReceived && _ctx.markReceived.apply(_ctx, arguments);
    })
  }, "标记未领")) : (_openBlock(), _createElementBlock("span", {
    key: 1,
    class: "mark green",
    onClick: _cache[1] || (_cache[1] =
    //@ts-ignore
    function () {
      return _ctx.markReceived && _ctx.markReceived.apply(_ctx, arguments);
    })
  }, "标记已领"))], 64)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", null, [_hoisted_5, _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.item.stone_no), 1)]), _createElementVNode("div", null, [_hoisted_7, _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.item.stone_specifications), 1)]), _createElementVNode("div", null, [_hoisted_9, _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.item.release_unit), 1)]), _createElementVNode("div", null, [_hoisted_11, _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.item.release_nums), 1)]), _createElementVNode("div", null, [_hoisted_13, _createElementVNode("span", {
    class: _normalizeClass(["info", {
      blue: _ctx.item.release_status == 1
    }])
  }, _toDisplayString(_ctx.item.release_status ? '已领' : '未领'), 3)])]), _createElementVNode("div", _hoisted_14, [_hoisted_15, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.archives, function (iten, indey) {
    return _openBlock(), _createElementBlock("div", {
      key: indey,
      class: "flex align-center justify-between"
    }, [_createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("span", _hoisted_18, _toDisplayString(iten.position), 1)]), _createElementVNode("div", _hoisted_19, [_hoisted_20, _createElementVNode("span", _hoisted_21, _toDisplayString(iten.stone_stock), 1)])]);
  }), 128))])]);
}